import net from "App/net";
import events from "App/events";

var Client = function() {

};

Client.prototype.find = function(vesselId) {
    var filter = {
        vesselId: vesselId,
    };

    return net.get("/FuelTanks/Find", filter);
};

Client.prototype.create = function(fuelTank) {
    return net.post("/FuelTanks", fuelTank);
};

Client.prototype.remove = function(fuelTank) {
    return net.del("/FuelTanks/" + fuelTank.id).done(function() {
        events.fuelTankDeleted.dispatch(fuelTank);
    });
};

export default new Client();